import React from "react";
import { Layout } from "core/components/Layout";
import { QualityAuditsEmailConfigurationHeader } from "quality_audits_email_configuration/components/QualityAuditsEmailConfigurationHeader";
import { QualityAuditsEmailConfigurationList } from "quality_audits_email_configuration/components/QualityAuditsEmailConfigurationList";

export const QualityAuditsEmailConfigurationView = () => {
  return (
    <Layout
      pageSubheader={<QualityAuditsEmailConfigurationHeader />}
      pageTitle="QA Email Configuration"
    >
      <QualityAuditsEmailConfigurationList />
    </Layout>
  );
};
